import {
  SUGGESTION_PREFIXES,
  SUGGESTION_SUFFIXES,
} from '@/lib/constants/domains'

export const getDomainSuggestions = name => {
  const prefixes = SUGGESTION_PREFIXES
  const suffixes = SUGGESTION_SUFFIXES
  const prefixCombinations = prefixes.map(prefix => `${prefix}${name}`)
  const suffixCombinations = suffixes.map(suffix => `${name}${suffix}`)
  return [...prefixCombinations, ...suffixCombinations]
}
